module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialogShow) ? _c('SmartDialog', {
    attrs: {
      "title": _vm.dialogLabel
    },
    model: {
      value: (_vm.filterVisible),
      callback: function($$v) {
        _vm.filterVisible = $$v
      },
      expression: "filterVisible"
    }
  }, [_c('SmartForm', {
    attrs: {
      "labelPosition": "right",
      "btnPosition": "center",
      "btnLabel": false,
      "isWidthAll": true,
      "labelSize": 4,
      "formList": _vm.formList,
      "values": _vm.dialogFormValues,
      "columns": _vm.columns,
      "buttonList": _vm.dialogButtonList,
      "formEnterIndex": 0
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a82a2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterBox/SeniorFilter.vue
// module id = 1729
// module chunks = 1